export default __webpack_public_path__ + "static/media/4star.03cc73b2.svg";